import { SCHEMA_VERSION } from '../constants';

/** 每个函数把 fromVersion 的文档迁到 fromVersion + 1。 */
export type Migration = (doc: Record<string, unknown>) => Record<string, unknown>;

/** 索引 = fromVersion。v1 是初始版本，暂无迁移。 */
export const MIGRATIONS: Record<number, Migration> = {
  // 2: (doc) => ({ ...doc, schemaVersion: 3, ... }),
};

export function migrateDocument(input: Record<string, unknown>): Record<string, unknown> {
  let doc = input;
  let v = typeof doc.schemaVersion === 'number' ? doc.schemaVersion : 1;
  if (v > SCHEMA_VERSION) {
    throw new Error(`文档版本 v${v} 高于当前支持的 v${SCHEMA_VERSION}，请升级应用`);
  }
  while (v < SCHEMA_VERSION) {
    const fn = MIGRATIONS[v];
    if (!fn) throw new Error(`缺少 v${v} → v${v + 1} 的文档迁移函数`);
    doc = fn(doc);
    v += 1;
    doc = { ...doc, schemaVersion: v };
  }
  return doc;
}
